var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowInsert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.54785 7.00313V13.8333C6.54785 14.0104 6.48792 14.1588 6.36806 14.2785C6.2482 14.3984 6.09973 14.4583 5.92264 14.4583C5.74542 14.4583 5.59702 14.3984 5.47744 14.2785C5.35771 14.1588 5.29785 14.0104 5.29785 13.8333V5.62813C5.29785 5.41479 5.37007 5.2359 5.51452 5.09146C5.65882 4.94715 5.83771 4.875 6.05119 4.875H14.2562C14.4333 4.875 14.5817 4.93493 14.7016 5.05479C14.8213 5.17465 14.8812 5.32313 14.8812 5.50021C14.8812 5.67743 14.8213 5.82583 14.7016 5.94542C14.5817 6.06514 14.4333 6.125 14.2562 6.125H7.42598L15.1954 13.9023C15.3106 14.0177 15.3669 14.1627 15.3643 14.3373C15.3617 14.512 15.3026 14.6571 15.1872 14.7725C15.0719 14.8878 14.9283 14.9454 14.7562 14.9454C14.5842 14.9454 14.4406 14.8878 14.3251 14.7725L6.54785 7.00313Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowInsert);
export default __webpack_public_path__ + "static/media/arrow_insert.03630c5bfe438edbcd0c51b6a626b860.svg";
export { ForwardRef as ReactComponent };